import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listAuditTrail as listAuditTrailService } from "../../services/AuditTrailService";
import {
  AuditTrailList,
  AuditTrailListParam,
  AuditTrailState,
} from "../../interfaces/audit-trail-interface";

export const listAuditTrail = createAsyncThunk(
  "products/listAuditTrail",
  async (data: AuditTrailListParam, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const auditTrail = await listAuditTrailService(data);
      return auditTrail.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const auditTrailSlice = createSlice({
  name: "auditTrail",
  initialState: {
    auditTrail: {
      data: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 1,
    } as AuditTrailList,
    status: "idle",
    error: null,
  } as AuditTrailState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listAuditTrail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listAuditTrail.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.auditTrail = action.payload;
        state.error = null;
      })
      .addCase(listAuditTrail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

const auditTrailReducer = auditTrailSlice.reducer;

export default auditTrailReducer;
